<template>
    <ul class="nav-list" :class="{ 'nav-list-sub': subList }">
        <li v-for="category in sortedCategories"
            class="nav-item"
            :class="{ active: isSelected(category.id) }">

            <a class="nav-link"
               :href="basePath + category.slug + '/'"
               @click.prevent="selectCategory(category)">{{ category.name }}<span>{{ category.products_count }}</span>
            </a>

            <catalog-categories v-if="category.subCategories && showSubCategories(category)"
                                :categoriesList="category.subCategories"
                                :sub-list="true"></catalog-categories>
        </li>
    </ul>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
    name: 'CatalogCategories',
    props: {
        categoriesList: {
            required: false,
            default: () => []
        },
        subList: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    methods: {
        ...mapActions('catalog', [
            'setCategoryId',
        ]),
        isSelected (categoryId) {
            return this.$store.state.catalog.categoryId === categoryId;
        },
        showSubCategories (category) {
            category.subCategories = _.isArray(category.subCategories) ?
                category.subCategories : Object.values(category.subCategories);

            return category.subCategories && category.subCategories.length
                && (category.id === this.categoryId || this.subCategorySelected(category));
        },
        subCategorySelected (category) {
            return category.subCategories.filter(subCategory => subCategory.id === this.categoryId || this.subCategorySelected(subCategory)).length;
        },
        selectCategory (category) {
            if (parseInt(this.$root.gender) === parseInt(category.gender)) {
                this.setCategoryId(category.id);
            } else {
                let url = this.basePath + category.slug + '/';
                if (this.stock) {
                    url += '?code=' + this.stock.code;
                }
                window.location.href = url;
            }
        }
    },
    computed: {
        ...mapState('catalog', [
            'categoryId',
            'basePath',
        ]),
        ...mapGetters('catalog', [
            'findCategoryById',
        ]),
        categories () {
            return this.categoriesList && this.categoriesList.length ? this.categoriesList : this.$store.state.catalog.categories;
        },
        sortedCategories () {
            let categories = this.categories;

            let result = [];

            let selected = categories.find(item => item.id === this.categoryId);

            if (!selected) {
                for (let i in categories) {
                    if (this.subCategorySelected(categories[i])) {
                        selected = categories[i];

                        break;
                    }
                }
            }

            if (selected) {
                result.push(selected);

                return result.concat(categories.filter(item => item.id !== selected.id))
            }

            return categories;
        }
    }
}
</script>
